import Tabs, { TabItem } from 'components/Tabs';
import { DEALER_CONFIG_TABS, DEALER_CONFIG_TABS_IDS } from 'features/Dealers/constants';
import * as React from 'react';
import { IProps } from './types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useLocation, Redirect } from 'react-router-dom';
import { RootState } from '../../store/types';
import { getEngineDealerAPI, getDealerCountryAPI } from './state/actions';
import { Loader } from '../../components/Loader'
import { serviceLoading } from 'common/loaderReducer';
import { GET_ENGINEDATA_API_REQUEST } from 'features/Dealers/state/actionTypes';
import { Dealer } from 'features/Dealers/DealerSelect/state/types';
import { editSelectedDealer, getDealerAPI, getDealerByIdAPI, updateSelectedDealer } from 'features/Dealers/DealerSelect/state/actions';
import { editCurrentSelectedListing, getListingsForDealer, listingsChanges } from 'features/Dealers/Listings/state/actions';
import { getEngineLocationsAPI } from 'features/Dealers/DealerConfiguration/Departments/state/actions';
import { getLMDepartmentsAPI } from 'features/Dealers/DealerConfiguration/Departments/state/actions';
import ListingConfiguration   from 'features/Dealers/DealerConfiguration';
import ConnectOption from 'features/Dealers/ConnectByLabel';
import Performance from './Performance'
import Departments from "./DealerConfiguration/Departments"
import AdvancedLm from "./AdvancedLm"
import Reviews from "./Reviews"
import { isConstructorDeclaration } from 'typescript';
import { getPlatformSecurityApi } from 'features/Security/state/actions';
import { getCountryStateAPI } from './state/actions';
import { role2 } from 'features/Home/constants';
import InformationScreen from './InformationScreen';
import { blurAppRequest } from 'features/Security/state/actions'
import { hasDealerPermissions } from './state/utils';

const DealerDetail = (props: IProps) => {

    const [selectedTab, setSelectedTab] = React.useState({ ...DEALER_CONFIG_TABS[0] });
    const [unauthorizedPage, setUnauthorizedPage] = React.useState(false);

    const tabItems = React.useMemo(() => {
        return DEALER_CONFIG_TABS.map(ti => {
            return {
                ...ti,
                selected: ti.internalName === selectedTab.internalName
            }
        })
    }, [selectedTab]);

    const dispatch = useDispatch();
    const location = useLocation()
    const history = useHistory();

    const rootProps = useSelector((rootState: RootState) => {
        return {
            dealers: rootState.dealers.dealer.dealers,
            security: rootState.security,
            page: rootState.dealers.dealer.page,
            limit: rootState.dealers.dealer.limit,
            error: rootState.dealers.dealer.error,
            query: rootState.dealers.dealer.query,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            engineDealer: rootState.dealers.enginedealer.enginedealer,
            isLoading: serviceLoading(rootState, [GET_ENGINEDATA_API_REQUEST]),
            menuItems: rootState.menu.items,
            connect: rootState.dealers.connectByLabel.connect,
            dealerLMInfo: rootState.dealers.listing.currentListing.data.dealerLMInfo,
            specialHours: rootState.dealers.listing.currentListing.specialHoursData.specialHoursData?.specialHours,
            keywords: rootState.dealers.listing.currentListing.keywordsData.keywordsData?.keywords,
            originalDealerCategories: rootState.dealers.listing.currentListing.categories.originalDealerCategories,
            mediaData: rootState.dealers.listing.currentListing.images.dealerImages?.mediadata,
            operationHours: rootState.dealers.listing.currentListing.operationHours.operationHours,
            countries: rootState.dealers.enginedealer.countries
        }
    }, shallowEqual);

    const searchDealers = () => {
        if (rootProps.security.user?.dealerGroup!=undefined && rootProps.security.user?.dealerGroup!="")            
            dispatch(getDealerAPI(rootProps.page, rootProps.limit, rootProps.query, rootProps.security.user?.dealerGroup, rootProps.security.user?.dealerId));
        else
            dispatch(getDealerAPI(rootProps.page, rootProps.limit, rootProps.security.user?.dealerId));
    }

    React.useEffect(() => {
        if (!rootProps.security.platformSecurity) {
            dispatch(getPlatformSecurityApi());
        }
        if (!rootProps.countries)
            dispatch(getCountryStateAPI());
    }, []);

    const redirectToUserPage = () => {
        history.push({
            pathname: location.pathname,
            search: `?dealer=${rootProps.security.user?.dealerId}`
        });
    }

    React.useEffect(() => {
        if (rootProps.security.platformSecurity && rootProps.security.user) {
            if (rootProps.security.user.role === role2) {
                if (!rootProps.dealers?.length) {
                    searchDealers();
                } else {
                    if (!hasDealerPermissions(location, rootProps.security.user, rootProps.dealers)) {
                        setUnauthorizedPage(true);
                        props.setHideModals(true);
                        dispatch(blurAppRequest(true));
                        setTimeout(() => {
                            redirectToUserPage();
                            setUnauthorizedPage(false);
                            props.setHideModals(false);
                            dispatch(blurAppRequest(false));
                        }, (rootProps.security.platformSecurity.unauthorizedParams.redirectTime ?? 3)*1000);
                    } else {
                        searchDealers()
                    }
                }
            }
            else
                dispatch(getDealerAPI(rootProps.page, rootProps.limit, rootProps.query));
        }
    }, [rootProps.page, rootProps.query, rootProps.security.platformSecurity, rootProps.security.user, JSON.stringify(rootProps.dealers)]);

    React.useEffect(() => {
        if (!rootProps.selectedDealer) {
            const dealerId = new URLSearchParams(location.search).get("dealer")
            if (dealerId && rootProps.dealers) {
                const dealerFound: Dealer | undefined = rootProps.dealers.find(d => d.id === dealerId)
                if (dealerFound) {
                    dispatch(editSelectedDealer(dealerFound));
                } else {
                    dispatch(getDealerByIdAPI(dealerId))
                }
            }
        }

    }, [rootProps.dealers])
    
    React.useEffect(() => {
        if (rootProps.selectedDealer && (rootProps.connect == undefined || rootProps.connect?.connected)) {

            dispatch(getEngineDealerAPI("GMB", rootProps.selectedDealer.id))
            dispatch(getListingsForDealer(rootProps.selectedDealer.id))
            dispatch(getEngineLocationsAPI("GMB", rootProps.selectedDealer.id))
            dispatch(getLMDepartmentsAPI("GMB",  rootProps.selectedDealer.id))            
            dispatch(getDealerCountryAPI(rootProps.selectedDealer.id))            
        }
    }, [rootProps.selectedDealer, rootProps.connect])

    function timeout(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms))
    }

    React.useEffect(() => {
        if (rootProps.selectedDealer) {            
            //to avoid multiple calls
            let isCancelled = false;
            const handleChange = async () => {
                await timeout(1000);
                if (!isCancelled && rootProps.selectedDealer) {
                    dispatch(listingsChanges(rootProps.selectedDealer.id))
                }            
            };
            handleChange();
            //cleanup
            return () => {
                isCancelled = true;
            };
        }
    }, [rootProps.selectedDealer, rootProps.dealerLMInfo, rootProps.originalDealerCategories, rootProps.mediaData, rootProps.keywords, rootProps.specialHours, rootProps.operationHours])
   
    React.useEffect(() => {
        if (rootProps.engineDealer) {
            const pathToPush = rootProps.menuItems?.find(f => f.internalName == "primary")?.url.find(u => u.status == (rootProps.engineDealer ? (rootProps.engineDealer.statusConected === 'ACTIVE' ? "CONNECTED" : "DISCONNECTED") : "DISCONNECTED"))?.path;
            if (pathToPush === undefined || !window.location.href.includes(pathToPush)) {
                const pathVerified = rootProps.engineDealer.statusConected !== "ACTIVE" ? pathToPush : location.pathname;
                history.push({
                    pathname: pathVerified,
                    search: `?dealer=${rootProps.selectedDealer?.id}`
                })
            }
        }
    }, [rootProps.engineDealer])

    if (rootProps.error)
    {
        return(<></>)
    }
    else
    {
        if (unauthorizedPage) {
            return (
                <InformationScreen id="unauthorizedPage" />
            )
        }
        if (rootProps.isLoading || !rootProps.selectedDealer || !rootProps.engineDealer) {
            return (
                <Loader />
                )
        }       
        else {
            return (
                <Switch>
                    <Route exact path={"/dealer/connect"} component={ConnectOption} />
                    <Route exact path={"/dealer/activity"} component={Performance} />
                    <Route exact path={"/dealer/departments/edit"} component={Departments} />
                    <Route exact path={"/dealer/department/:id"} component={ListingConfiguration} />
                    <Route exact path={"/dealer/advanced"} component={AdvancedLm} />
                    <Route exact path={"/dealer/primary"} component={ListingConfiguration} />
                    <Route exact path={"/dealer/reviews"} component={Reviews} />
                </Switch>
            )
        }
    }

}

export default DealerDetail;